var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.68,
    height: 82.68,
    viewBox: "0 0 82.68 82.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Information_3002553",
    transform: "translate(116 375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(-116 -375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M23.97,42.052,27,43.983l3.032-1.93a27.878,27.878,0,0,0,12.97-23.628V15L27,4.814,11,15v3.427A27.874,27.874,0,0,0,23.97,42.052ZM28.6,39.8,27,40.821,25.4,39.8a25.393,25.393,0,0,1-6.381-5.8,7.99,7.99,0,0,1,15.963,0A25.41,25.41,0,0,1,28.6,39.8ZM24.335,21.065V18.4a2.667,2.667,0,0,1,5.334,0v2.667a2.667,2.667,0,1,1-5.334,0Zm-10.668-4.6L27,7.977l13.335,8.485v1.963A25.285,25.285,0,0,1,37.067,30.9a10.71,10.71,0,0,0-6.04-6.369,5.285,5.285,0,0,0,1.31-3.462V18.4a5.334,5.334,0,0,0-10.668,0v2.667a5.285,5.285,0,0,0,1.31,3.462,10.714,10.714,0,0,0-6.04,6.369,25.285,25.285,0,0,1-3.271-12.47Z",
    transform: "translate(2.335 0.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 1.853,
    height: 2.78,
    transform: "translate(5.619 66.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 2.78,
    height: 2.78,
    transform: "translate(10.252 66.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 2.78,
    height: 2.78,
    transform: "translate(15.812 66.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M77.012,17H75.678V1H9V17H7.668A6.675,6.675,0,0,0,1,23.67v45.34a6.675,6.675,0,0,0,6.668,6.668H25v5.334H19.67V83.68H65.01V81.013H59.676V75.678H77.012a6.675,6.675,0,0,0,6.668-6.668V23.67A6.675,6.675,0,0,0,77.012,17ZM7.668,19.67h4v-16H73.011v45.34H11.668V22.337H9V51.675H75.678V19.67h1.334a4.006,4.006,0,0,1,4,4V65.01H25.556l-2.667-2.667H3.667V23.67A4.006,4.006,0,0,1,7.668,19.67ZM77.012,73.011H30.338v2.667H57.009v5.334H27.671v-8h-20a4.006,4.006,0,0,1-4-4v-4H21.785l2.667,2.667H81.013v1.334A4.006,4.006,0,0,1,77.012,73.011Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 21.311,
    height: 1.853,
    transform: "translate(48.242 5.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_385",
    "data-name": "Rectangle 385",
    width: 21.311,
    height: 2.78,
    transform: "translate(48.242 10.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 15.752,
    height: 2.78,
    transform: "translate(53.801 15.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 1.853,
    height: 2.78,
    transform: "translate(48.242 15.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 21.311,
    height: 2.78,
    transform: "translate(48.242 21.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    width: 21.311,
    height: 1.853,
    transform: "translate(48.242 26.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    width: 2.78,
    height: 1.853,
    transform: "translate(66.773 32.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 15.752,
    height: 1.853,
    transform: "translate(48.242 32.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 21.311,
    height: 2.78,
    transform: "translate(48.242 37.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 2.78,
    height: 2.78,
    transform: "translate(57.507 42.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 2.78,
    height: 2.78,
    transform: "translate(51.948 42.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 1.853,
    height: 2.78,
    transform: "translate(63.067 42.682)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareImg);
export default __webpack_public_path__ + "static/media/software-img.91d39a54f25697ce60eb72ce2371c303.svg";
export { ForwardRef as ReactComponent };